module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGARDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGITAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" 1-2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("An Apostle Called by God 1 Corinthians 1:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_vm._v("Thanksgiving 1 Corinthians 1:4-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap4"
    }
  }, [_vm._v("The Scandal of Division 1 Corinthians 1:10-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap5"
    }
  }, [_vm._v("Preaching the Gospel 1 Corinthians 1:17-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap6"
    }
  }, [_vm._v("True Wisdom 1 Corinthians 1:20-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap7"
    }
  }, [_vm._v("The Upside-Down Church 1 Corinthians 1:26-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap8"
    }
  }, [_vm._v("Paul’s Preaching Power 1 Corinthians 2:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap9"
    }
  }, [_vm._v("God’s Secret Wisdom 1 Corinthians 2:6-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap10"
    }
  }, [_vm._v("Spiritual People 1 Corinthians 2:13-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap11"
    }
  }, [_vm._v("Unspiritual People 1 Corinthians 3:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap12"
    }
  }, [_vm._v("Servants of God 1 Corinthians 3:5-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap13"
    }
  }, [_vm._v("The Principles of Divine Architecture 1 Corinthians 3:11-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap14"
    }
  }, [_vm._v("Christian Identity 1 Corinthians 3:16-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Upside-Down Person 1 Corinthians 3:18-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Identity 1 Corinthians 4:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Identity of the Corinthians 1 Corinthians 4:6-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Family 1 Corinthians 4:14-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church Discipline 1 Corinthians 5:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Different Standards 1 Corinthians 5:9-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resolving Differences Inside the Church 1 Corinthians 6:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Makes Christians Different 1 Corinthians 6:9-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Right and Wrong 1 Corinthians 6:12-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man and Woman 1 Corinthians 7:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Single Life 1 Corinthians 7:8-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed Marriages 1 Corinthians 7:10-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contented Life 1 Corinthians 7:17-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage 1 Corinthians 7:25-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom 1 Corinthians 7:32-38")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widowhood 1 Corinthians 7:39-40")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Offered to Idols 1 Corinthians 8:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom and Failure 1 Corinthians 8:9-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Self-Defense 1 Corinthians 9:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right to Compensation 1 Corinthians 9:7-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Commission to Preach the Gospel 1 Corinthians 9:15-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flexible Service 1 Corinthians 9:19-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Race 1 Corinthians 9:24-27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old and the New 1 Corinthians 10:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning from Experience 1 Corinthians 10:6-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body and Blood of Christ 1 Corinthians 10:14-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Going Too Far 1 Corinthians 10:23-29")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right Approach 1 Corinthians 10:30-33")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Imitation of Christ 1 Corinthians 11:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practical Application 1 Corinthians 11:4-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Order of Service 1 Corinthians 11:17-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Institution of Holy Communion 1 Corinthians 11:23-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing for Communion 1 Corinthians 11:27-34")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiritual Gifts 1 Corinthians 12:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unity in Diversity 1 Corinthians 12:4-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body 1 Corinthians 12:12-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spiritual Hierarchy 1 Corinthians 12:27-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Law of Love 1 Corinthians 13:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of Love 1 Corinthians 13:4-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future of Love 1 Corinthians 13:8-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy Versus Tongues 1 Corinthians 14:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Controlling the Power of Tongues 1 Corinthians 14:13-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ordering Public Worship 1 Corinthians 14:26-32")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decency and Order 1 Corinthians 14:33-40")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Confession of Faith 1 Corinthians 15:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Confession 1 Corinthians 15:8-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection 1 Corinthians 15:12-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Adam 1 Corinthians 15:20-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reign of Christ 1 Corinthians 15:25-28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dead 1 Corinthians 15:29-34")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection Body 1 Corinthians 15:35-44")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Adam 1 Corinthians 15:45-50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Trumpet 1 Corinthians 15:51-58")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almsgiving 1 Corinthians 16:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future Plans 1 Corinthians 16:5-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fellow Workers 1 Corinthians 16:10-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farewell 1 Corinthians 16:19-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The God of All Comfort 2 Corinthians 1:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Record 2 Corinthians 1:12-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Excuse 2 Corinthians 1:15-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Pain 2 Corinthians 2:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church’s Pain 2 Corinthians 2:5-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Preaching 2 Corinthians 2:12-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s References 2 Corinthians 3:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Covenant 2 Corinthians 3:5-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Veil 2 Corinthians 3:12-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding the Truth 2 Corinthians 4:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Earthen Vessels 2 Corinthians 4:7-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of Faith 2 Corinthians 4:13-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Earthly Tent 2 Corinthians 5:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Attitude 2 Corinthians 5:6-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeing Things from God’s Point of View 2 Corinthians 5:11-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Creation 2 Corinthians 5:16-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day of Salvation 2 Corinthians 6:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Challenge to the Corinthians 2 Corinthians 6:11-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Agony for the Corinthians 2 Corinthians 7:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titus 2 Corinthians 7:13-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Generosity 2 Corinthians 8:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ’s Love for Us 2 Corinthians 8:8-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teamwork 2 Corinthians 8:16-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almsgiving 2 Corinthians 9:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Reputation 2 Corinthians 10:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Modesty 2 Corinthians 10:13-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Apparent Foolishness 2 Corinthians 11:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Financial Independence 2 Corinthians 11:7-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The False Teachers 2 Corinthians 11:12-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Boasting 2 Corinthians 11:16-29")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Escape 2 Corinthians 11:30-33")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystical Vision 2 Corinthians 12:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thorn in Paul’s Flesh 2 Corinthians 12:7-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Credentials 2 Corinthians 12:11-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Impending Arrival 2 Corinthians 12:14-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Strength 2 Corinthians 13:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Examination 2 Corinthians 13:5-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" - E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITED")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCHES")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCRIPTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMELINE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRISTIC")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIOD")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")]), _vm._v("/W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0